import React from 'react';
import ReactDOM from 'react-dom/client';
import { AirDropProvider } from './utils/AirDropProvider';
import App from './components/App';
import './styles/styles.scss';
import { RecaptchaProvider } from './components/context/Recaptcha';
import './utils/i18.js';
import { LanguageProvider } from './components/context/Locale';
import { initializePendo } from './utils/pendoUtils';

const logoTreatment: string = window?.appAirDrop?.config?.logoTreatment;
const accountRootUrl: string = window?.appAirDrop?.config?.accountRootUrl;

// organisms are basically different apps. Progressive app has subset of functionality of legacy app. account mamnagement
// is its own thing. account management may have its own design (as coded currently), or can use a different design
const organism = () => {
  if (accountRootUrl) {
    return 'account_management';
  }
  if (logoTreatment === 'channels'
    || logoTreatment === 'channels_alt'
    || logoTreatment === 'p_dot_com'
    || logoTreatment === 'turbo'
    || logoTreatment === 'reskin') {
    return 'progressive';
  }
  return 'legacy';
};
// add new organizm for 'hed_evolution_light' -> EvolutionLight
// hed_evolution continues to use Legacy organism

// design is all about styling and page layout. css variable files use is driven by design
const design = () => {
  if (accountRootUrl) {
    return 'account_management';
  }
  if (logoTreatment === 'channels' || logoTreatment === 'channels_alt' || logoTreatment === 'turbo') {
    return 'progressive';
  }
  if (logoTreatment === 'p_dot_com') {
    return 'p_dot_com';
  }
  if (logoTreatment === 'reskin') {
    return 'reskin';
  }
  if (logoTreatment === 'hed_evolution') {
    return 'hed_evolution';
  }
  return 'legacy';
};

// design-specific css
import(`./styles/designs/${design()}/componentVariables.css`);

// design-specific oneTrust css
import(`./styles/designs/${design()}/onetrust.css`);

if (organism() === 'legacy') {
  initializePendo();
}

const ico = window.appAirDrop.config.faviconFilename;
const loginRootUrl = `${window.appAirDrop.config.loginRootUrl}/iesui/`;
if (ico && ico !== 'favicon.ico') {
  const link = document.querySelector("link[rel~='icon']") as any;
  if (link) {
    link.href = `${loginRootUrl}${ico}`;
  }
}

if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000);
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AirDropProvider>
      <RecaptchaProvider siteKey={window.appAirDrop.config.GOOGLE_RECAPTCHAV3_SITEKEY}>
        <LanguageProvider>
          <App organism={organism()} />
        </LanguageProvider>
      </RecaptchaProvider>
    </AirDropProvider>
  </React.StrictMode>,
);
